export default __webpack_public_path__ + "static/media/washing.80807de5.png";